module.exports = __webpack_public_path__ + "img/huanan.bf939542.png";